import { cleanArray } from './array';

export function classNamesMaybeToClassNameProp(classNameArray) {
  return cleanArray(classNameArray, [false]).join(" ");
}